<template>
  <AppModal v-model="showModal" dialog-titel="">
    <MarkupGenerator :page-data="markupData" :is-page="false" />
    <template #modal-footer>
      <AppButton
        :show-loading="showLoading"
        :disabled="!productPageStore.currentBundlePrice"
        class="w-full p-10 flex justify-end android-chrome-safe-padding"
        :full-width="screenIsSm"
        @on-click="emit('on-click-go-to-checkout')"
      >
        Fortsätt till kassan <nuxt-icon name="arrow-right" aria-hidden="true" />
      </AppButton>
    </template>
  </AppModal>
</template>

<script lang="ts" setup>
import { useSsrSafeViewportState } from '~/composables/general/useSsrSafeViewportState';
import type { MarkupData } from '~/repository/modules/category.module';

const productPageStore = useMyProductPageStore();

// This won't cause a hydration issue here because the modal is lazy loaded
const { screenIsSm } = useSsrSafeViewportState();

interface Props {
  showLoading: boolean;
}
defineProps<Props>();

const emit = defineEmits(['on-click-go-to-checkout']);

const showModal = defineModel<boolean>();
const markupData = computed<MarkupData | null | undefined>(() => ({
  PageContent: productPageStore.popupDiscounts,
}));
</script>
